<template>
  <div>
    <div class="mb-6 flex flex-nowrap justify-between">
      <h1 class="mr-3 text-2xl text-gray-777 font-roboto uppercase">Atendimentos</h1>
    </div>

    <files-modal ref="modalFiles">
    </files-modal>

    <data-table
      v-if="loadTable"
      v-model:columns="columns"
      :route="'/patients/appointments/' + patient.id"
      no-data-label="Nenhuma consulta cadastrada"
      no-result-label="Nenhuma consulta encontrada"
    >
      <template #table.cell.content.actions="{ value, row }">
        <div class="inline-grid grid-cols-1 gap-4 ">
          <button
            v-if="row.openRoom"
            class="btn-primary font-normal text-xs px-4 py-2.5"
            @click="openRoom(row)">
              Acessar consulta
          </button>

          <button
            v-if="row.allowReschedule"
            class="btn-primary font-normal text-xs px-4 py-2.5"
            @click="openModalReschedule(row)">
              Reagendar consulta
          </button>

          <button
            v-if="row.patient_files_count != 0"
            class="btn-primary font-normal text-xs px-4 py-2.5 block w-full"
            @click="openModalFiles(row.id, 'files')">
              Ver documentos
              <font-awesome-icon icon="fa-file-arrow-up" class="ml-2" />
          </button>

          <button
            v-if="row.patient_description_count != 0"
            class="btn-primary font-normal text-xs px-4 py-2.5 block w-full"
            @click="openModalFiles(row.id, 'description')">
              Ver Descrições
              <font-awesome-icon icon="fa-clipboard" class="ml-2" />
          </button>
        </div>

      </template>

      <template #grid.content.body.actions="{ value, row }">
        <div class="inline-grid grid-cols-1 gap-4 ">
          <button
            v-if="row.openRoom"
            class="btn-primary font-normal text-xs px-4 py-2.5"
            @click="openRoom(row)">
              Acessar consulta
          </button>

          <button
            v-if="row.allowReschedule"
            class="btn-primary font-normal text-xs px-4 py-2.5"
            @click="openModalReschedule(row)">
              Reagendar consulta
          </button>

          <button
            v-if="row.patient_files_count != 0"
            class="btn-primary font-normal text-xs px-4 py-2.5 block w-full"
            @click="openModalFiles(row.id, 'files')">
              Ver documentos
              <font-awesome-icon icon="fa-file-arrow-up" class="ml-2" />
          </button>

          <button
            v-if="row.patient_description_count != 0"
            class="btn-primary font-normal text-xs px-4 py-2.5 block w-full"
            @click="openModalFiles(row.id, 'description')">
              Ver Descrições
              <font-awesome-icon icon="fa-clipboard" class="ml-2" />
          </button>
        </div>

      </template>

      <template #table.cell.content.patient_return="{ value, row }">
          <div v-if="row.appointment_id" class="text-primary">Retorno agendado</div>
          <div v-else>
            <button v-if="row.allowReturnButton" class="btn-primary font-normal text-xs px-4 py-2.5" @click="openModalReturn(row)">Liberar Retorno</button>
            <div v-if="row.allow_return" class="text-primary">Retorno liberado</div>
          </div>
      </template>
      <template #grid.content.body.patient_return="{ value, row }">
        <div v-if="row.appointment_id" class="text-primary">Retorno agendado</div>
          <div v-else>
            <button v-if="row.allowReturnButton" class="btn-primary font-normal text-xs px-4 py-2.5" @click="openModalReturn(row)">Liberar Retorno</button>
            <div v-if="row.allow_return" class="text-primary">Retorno liberado</div>
          </div>
      </template>

      <template #table.cell.content.date_end="{ value, row }">
        <template v-if="row.type_service != 'telemedicine'">{{ value }}</template>
        <template v-else>
          <popover class="mr-8 md:mr-0" placement="bottom-end">
            <template #default>
              <span class="text-primary font-semibold cursor-pointer">
                {{ value }}
              </span>
            </template>
            <template #dropdown>
              <div class="p-4 bg-white shadow_box rounded-lg text-xs">
                <div class="grid gap-4 grid-cols-3">
                  <div></div>
                  <div>Entrada</div>
                  <div>Saída</div>
                  <div>Profissional</div>
                  <div>
                    {{ row.professional_date_join ? row.professional_date_join.substr(10, 6) : '-' }}
                  </div>
                  <div>
                    {{ row.professional_date_out ? row.professional_date_out.substr(10, 6) : '-' }}
                  </div>
                  <div>Paciente</div>
                  <div>
                    {{ row.patient_date_join ? row.patient_date_join.substr(10, 6) : '-' }}
                  </div>
                  <div>
                    {{ row.patient_date_out ? row.patient_date_out.substr(10, 6) : '-' }}
                  </div>
                </div>
              </div>
            </template>
          </popover>
        </template>
      </template>

      <template #table.content.body.date_end="{ value, row }">
        <template v-if="row.type_service != 'telemedicine'">{{ value }}</template>
        <template v-else>
          <popover class="mr-8 md:mr-0" placement="bottom-end">
            <template #default>
              <span class="text-primary font-semibold cursor-pointer">
                {{ value }}
              </span>
            </template>
            <template #dropdown>
              <div class="p-4 bg-white shadow_box rounded-lg text-xs">
                <div class="grid gap-4 grid-cols-3">
                  <div></div>
                  <div>Entrada</div>
                  <div>Saída</div>
                  <div>Profissional</div>
                  <div>
                    {{ row.professional_date_join ? row.professional_date_join.substr(10, 6) : '-' }}
                  </div>
                  <div>
                    {{ row.professional_date_out ? row.professional_date_out.substr(10, 6) : '-' }}
                  </div>
                  <div>Paciente</div>
                  <div>
                    {{ row.patient_date_join ? row.patient_date_join.substr(10, 6) : '-' }}
                  </div>
                  <div>
                    {{ row.patient_date_out ? row.patient_date_out.substr(10, 6) : '-' }}
                  </div>
                </div>
              </div>
            </template>
          </popover>
        </template>
      </template>
    </data-table>

    <modal-return ref="modalReturn" @confirm="reloadTable" :modal-align="this.appointmentOpen() ? 'left' : 'center'" :modal-backdrop="!this.appointmentOpen()"></modal-return>
    <modal-reschedule ref="modalReschedule" @confirm="reloadTable" :modal-align="this.appointmentOpen() ? 'left' : 'center'" :modal-backdrop="!this.appointmentOpen()"></modal-reschedule>
  </div>
</template>

<script>
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'

import DataTable from '@/Shared/Components/DataTable'
import ModalReturn from '@/Shared/Modal/ModalReturn'
import ModalReschedule from '@/Shared/Modal/ModalReschedule'
import JitsiMeet from '@/Shared/Components/JitsiMeet'
import Popover from '@/Shared/Components/Popover'
import FilesModal from '@/Shared/Modal/FilesModal'

export default {
  inject: ['patient', 'openAppointmentSide', 'appointmentOpen'],
  components: {
    DataTable,
    ModalReturn,
    ModalReschedule,
    JitsiMeet,
    Popover,
    FilesModal,
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  mounted() {
    console.log('Paciente injetado:', this.patient);
  },

  data() {
    return {
      loadTable: true,
      columns: [
        {
          uniqid: 'date_start',
          label: 'Data',
          field: 'date_start',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => this.$filters.formatDate(row.date_start),
        },
        {
          uniqid: 'date_end',
          label: 'Horário',
          field: 'date_end',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.date_start.substr(10, 6) + ' - ' + row.date_end.substr(10, 6),
        },
        {
          uniqid: 'specialty',
          label: 'Especialidade',
          field: 'specialties.name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.specialty ? row.specialty.name : ''
        },
        {
          uniqid: 'is_return',
          label: 'Retorno',
          visible: this.patient?.b2b === false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.is_return ? row.is_return : ''
        },
        {
          uniqid: 'patient_return',
          label: 'Retorno',
          visible:  this.patient?.b2b === false,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => '',
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: this.user.role == 2,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
  methods: {
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },
    openRoom(item) {
      this.openAppointmentSide(item);
    },

    openModalFiles(appointment_id, filter) {
      this.$refs.modalFiles.openModal(appointment_id, filter)
    },

    openModalReturn(item) {
      this.$refs.modalReturn.openModalReturn(item, `/patients/appointments/return/${item.id}`);
    },
    openModalReschedule(item) {
      this.$refs.modalReschedule.openModalReschedule(item, `/appointments/reschedule/${item.id}`);
    },
  },
}
</script>
